export enum PartnerHotelSearchRouteQueryParams {
  checkInDate = 'checkInDate',
  checkOutDate = 'checkOutDate',
  // passed to nuitee
  discountCode = 'discountCode',
  eventId = 'eventId',
  name = 'name',
  placeId = 'placeId',
  utm_campaign = 'utm_campaign',
  utm_medium = 'utm_medium',
  utm_source = 'utm_source',
  utm_source_secondary = 'utm_source_secondary',
}

export type HotelSearchParamsType = {
  clientReference: string;
  placeId?: string | null;
  locationSource?: string | null;
  name?: string | null;
  checkin?: string | null;
  checkout?: string | null;
  currency?: string;
  language?: string;
  xData?: string;
  utm_source?: string | null;
  utm_source_secondary?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
};

export interface TelHotelSearchRedirectParams {
  destinationName: 'joy' | 'stays' | 'hotels';
  destinationUrl: URL;
  onTelemetrySend?: () => void;
  clientReference: string;
  locationPlaceId?: string | null;
  locationName?: string | null;
  locationSource?: string | null;
  checkin?: string | null;
  checkout?: string | null;
  utm_source?: string | null;
  utm_source_secondary?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
}
